import { useEffect, useState } from 'react';

const useCoordinates = (ref: React.RefObject<HTMLElement> | null) => {
  const [coordinates, setCoordinates] = useState<DOMRect | null>(null);
  useEffect(() => {
    if (!ref?.current) {
      setCoordinates(null);
    } else if (!coordinates) {
      setCoordinates(ref.current.getBoundingClientRect());
    }
    function onChange() {
      if (ref?.current) {
        setCoordinates(ref.current.getBoundingClientRect());
      }
    }
    window.addEventListener('resize', onChange);
    window.addEventListener('scroll', onChange);
    return () => {
      window.removeEventListener('resize', onChange);
      window.removeEventListener('scroll', onChange);
    };
  }, [ref, coordinates]);
  return coordinates;
};

export default useCoordinates;
